import { AnyAction } from 'redux';

import {
  FETCH_ASSESSMENT_ERROR,
  FETCH_ASSESSMENT_START,
  FETCH_ASSESSMENT_SUCCESS,
  SSI_DOCUMENT_NUMBER_CHANGE,
} from 'actions/assessment/types';
import { SSIDetails } from 'types/check';
import { Error } from 'types/error';
import {
  IFetchAssessmentError,
  IFetchAssessmentSuccess,
  ISsiDocumentNumberChange,
} from 'actions/assessment';

export type AssessmentReducerType = {
  isLoading: boolean;
  jobToken: string;
  pagesCounter: number;
  selectedSsiDocumentNumber: string | null;
  ssiDetails: SSIDetails | null;
  isBrandedDocument: boolean;
  error: Error | null;
};

export const initialState = (): AssessmentReducerType => ({
  isLoading: true,
  jobToken: '',
  pagesCounter: 0,
  selectedSsiDocumentNumber: null,
  ssiDetails: null,
  isBrandedDocument: false,
  error: null,
});

function handleSsiDocumentNumberChange(
  state: AssessmentReducerType,
  action: ISsiDocumentNumberChange
) {
  return {
    ...state,
    selectedSsiDocumentNumber: action.selectedSsiDocumentNumber,
  };
}

function handleFetchAssessmentStart(state: AssessmentReducerType) {
  return {
    ...state,
    isLoading: true,
  };
}

function handleFetchAssessmentSuccess(
  state: AssessmentReducerType,
  action: IFetchAssessmentSuccess
) {
  return {
    ...state,
    ...action.assessment,
    isLoading: false,
    isBrandedDocument: !!action.assessment.ssiDetails?.ssiDocument,
  };
}

function handleFetchAssessmentError(
  state: AssessmentReducerType,
  action: IFetchAssessmentError
) {
  return {
    ...state,
    isLoading: false,
    error: { ...action.error },
  };
}

export default function AssessmentReducer(
  state = initialState(),
  action: AnyAction
) {
  switch (action.type) {
    case FETCH_ASSESSMENT_START:
      return handleFetchAssessmentStart(state);
    case FETCH_ASSESSMENT_SUCCESS:
      return handleFetchAssessmentSuccess(
        state,
        action as IFetchAssessmentSuccess
      );
    case FETCH_ASSESSMENT_ERROR:
      return handleFetchAssessmentError(state, action as IFetchAssessmentError);
    case SSI_DOCUMENT_NUMBER_CHANGE:
      return handleSsiDocumentNumberChange(
        state,
        action as ISsiDocumentNumberChange
      );
    default:
      return state;
  }
}
